<template>
    <Form v-slot="{ handleSubmit }" as="div">
        <slot :submit="submit" :handle-submit="handleSubmit" />
    </Form>
</template>

<script lang="ts">
import Utils from '../../utils/Utils';
import { Form } from 'vee-validate';
import DynamicsUtils from '../../utils/DynamicsUtils';
import { PropType, toRaw } from 'vue';
import Enums from '../../utils/Enums';
import axios from 'axios';

export interface DynamicsFieldMapping {
    FormFieldName: string;
    DataverseFieldName: string;
}

export default {
    // eslint-disable-next-line vue/no-reserved-component-names
    components: { Form },
    props: {
        uuid: { type: String },
        agreed: { type: Boolean, default: false },
        dynamicsSend: { type: Boolean, default: false },
        dynamicsFormId: { type: String },
        dynamicsApiUrl: { type: String },
        dynamicsLibUrl: { type: String },
        dynamicsFieldMappings: { type: Array as PropType<Array<DynamicsFieldMapping>>, default: () => [] },
    },
    data() {
        return {
            formElement: undefined,
            genericDynamicsFieldMappings: undefined,
        };
    },
    watch: {
        /**
         * Special method for the login component, where users might have to agree to terms & conditions first
         */
        async agreed() {
            if (this.agreed) {
                this.submit();
            }
        },
    },
    created(): void {
        if (this.dynamicsSend && this.dynamicsLibUrl) {
            Utils.addScript(this.dynamicsLibUrl);
        }
    },
    async mounted(): Promise<void> {
        this.formElement = this.$el.querySelector('form');
        const params = new URLSearchParams(window.location.search);
        if (params.has('mgnlFormToken')) {
            const actionResult = document.getElementById(this.uuid);
            if (actionResult) {
                actionResult.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                });
            }
        }

        // get csrf via REST endpoint if not set
        const csrf: HTMLInputElement = this.$el.querySelector('#csrf') as HTMLInputElement;
        if (csrf && !csrf.value) {
            await axios
                .get(Utils.getLocalStorage(Enums.STORAGE_KEY.CONTEXT_PATH) + Enums.API.LOCATION + Enums.API.CSRF)
                .then(res => {
                    csrf.value = res.data;
                });
        }

        this.addEventListeners();

        DynamicsUtils.loadGenericFieldMappings().then(mappings => (this.genericDynamicsFieldMappings = mappings));
    },
    methods: {
        submit(): void {
            if (this.formElement) {
                if (this.dynamicsSend) {
                    // dynamics form capture
                    DynamicsUtils.submitDynamicsForm(
                        this.formElement,
                        toRaw(this.genericDynamicsFieldMappings),
                        this.dynamicsFieldMappings,
                        this.dynamicsFormId,
                        this.dynamicsApiUrl,
                        this.formElement.submit // callback which is called after submitting dynamics form
                    );
                } else {
                    // normal submit
                    this.formElement.submit();
                }
            }
        },
        addEventListeners() {
            if (this.formElement) {
                this.formElement.addEventListener('focusin', () => this.pushEvent('lz_form_start'), {
                    once: true,
                });
                this.formElement.addEventListener('submit', () => this.pushEvent('lz_form_submit'));
            }
        },
        pushEvent(event: string) {
            console.log(`Pushing event ${event}.`);
            if (this.$gtm && this.$gtm.enabled()) {
                window.dataLayer.push({
                    event: event,
                });
            }
        },
    },
};
</script>
